// NAMI — Interactions theme Shopify
document.addEventListener('DOMContentLoaded', () => {

  // ----- Sticky header -----
  const header = document.querySelector('.site-header');
  const onScroll = () => {
    if (window.scrollY > 60) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ----- Multi-mega-menu -----
  const allMegas = document.querySelectorAll('.mega-menu');
  let closeTimer = null;
  const closeAll = () => { allMegas.forEach(m => m.classList.remove('is-open')); };
  const openOne = (target) => { clearTimeout(closeTimer); closeAll(); if (target) target.classList.add('is-open'); };
  const scheduleClose = () => { closeTimer = setTimeout(closeAll, 120); };

  document.querySelectorAll('[data-menu-target]').forEach(t => {
    const targetId = t.dataset.menuTarget;
    const target = document.getElementById(targetId);
    if (!target) return;
    t.addEventListener('mouseenter', () => openOne(target));
    t.addEventListener('mouseleave', scheduleClose);
    t.addEventListener('focus', () => openOne(target));
    t.addEventListener('click', (e) => { e.preventDefault(); openOne(target); });
  });
  allMegas.forEach(m => {
    m.addEventListener('mouseenter', () => { clearTimeout(closeTimer); m.classList.add('is-open'); });
    m.addEventListener('mouseleave', scheduleClose);
  });

  // ----- Burger mobile -----
  document.querySelectorAll('[data-menu-trigger]').forEach(t => {
    if (t.hasAttribute('data-menu-target')) return;
    t.addEventListener('click', (e) => {
      e.preventDefault();
      const firstMega = document.querySelector('.mega-menu');
      if (firstMega) firstMega.classList.toggle('is-open');
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAll();
      const rm = document.getElementById('region-modal');
      if (rm) rm.classList.remove('is-open');
    }
  });

  // ----- Carousel : Prev/Next avec BOUCLE (wrap-around) -----
  document.querySelectorAll('.carousel-wrap').forEach(wrap => {
    const car = wrap.querySelector('.carousel');
    const prev = wrap.querySelector('[data-prev]');
    const next = wrap.querySelector('[data-next]');
    if (!car) return;
    const step = () => Math.max(280, car.clientWidth * 0.6);
    const atEnd = () => car.scrollLeft + car.clientWidth >= car.scrollWidth - 4;
    const atStart = () => car.scrollLeft <= 4;
    if (next) next.addEventListener('click', () => {
      if (atEnd()) {
        car.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        car.scrollBy({ left: step(), behavior: 'smooth' });
      }
    });
    if (prev) prev.addEventListener('click', () => {
      if (atStart()) {
        car.scrollTo({ left: car.scrollWidth, behavior: 'smooth' });
      } else {
        car.scrollBy({ left: -step(), behavior: 'smooth' });
      }
    });
  });

  // ----- Region modal -----
  const regionModal = document.getElementById('region-modal');
  if (regionModal) {
    const openRegion = () => regionModal.classList.add('is-open');
    const closeRegion = () => regionModal.classList.remove('is-open');
    document.querySelectorAll('[data-region-open]').forEach(el => {
      el.addEventListener('click', (e) => { e.preventDefault(); openRegion(); });
    });
    regionModal.addEventListener('click', (e) => {
      if (e.target.closest('[data-region-close]')) closeRegion();
    });
  }

  // ----- PDP: selection taille -----
  document.querySelectorAll('.pdp-sizes').forEach(group => {
    group.addEventListener('click', (e) => {
      const btn = e.target.closest('.pdp-size');
      if (!btn) return;
      group.querySelectorAll('.pdp-size').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      const variantId = btn.dataset.variantId;
      if (variantId) {
        const hidden = document.querySelector('input[name="id"]');
        if (hidden) hidden.value = variantId;
      }
    });
  });

  // ----- PDP: accordeons -----
  document.querySelectorAll('.pdp-section').forEach(sec => {
    const head = sec.querySelector('.pdp-section-title');
    const body = sec.querySelector('.pdp-section-body');
    if (!head || !body) return;
    body.style.maxHeight = '0';
    body.style.overflow = 'hidden';
    body.style.transition = 'max-height .35s ease';
    head.style.cursor = 'pointer';
    head.addEventListener('click', () => {
      const open = body.style.maxHeight !== '0px' && body.style.maxHeight !== '';
      body.style.maxHeight = open ? '0' : body.scrollHeight + 'px';
      const toggle = head.querySelector('.pdp-toggle');
      if (toggle) toggle.textContent = open ? '+' : '−';
    });
  });
});
